<div class="libraries-page">
  <app-header [forceLightBackground]="true"></app-header>

  <div class="libraries-page--content">
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <div class="libraries-page--main">
      <div class="libraries-page--container">
        <!-- Tabs: Articles / Video + View toggle -->
        <div class="libraries__tabs-row">
          <div class="libraries__tabs">
            <button
              type="button"
              class="libraries__tab"
              [class.libraries__tab--active]="activeTab === 'article'"
              (click)="setTab('article')"
            >
              ARTICLES
            </button>
            <button
              type="button"
              class="libraries__tab"
              [class.libraries__tab--active]="activeTab === 'video'"
              (click)="setTab('video')"
            >
              VIDEO
            </button>
          </div>
          <div class="libraries__view-toggle" *ngIf="!loading && !loadError && filteredItems.length > 0 && activeTab === 'video'">
            <button
              type="button"
              class="libraries__view-btn"
              [class.libraries__view-btn--active]="viewMode === 'grid'"
              (click)="setViewMode('grid')"
              aria-label="Grid view"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
              </svg>
              Grid
            </button>
            <button
              type="button"
              class="libraries__view-btn"
              [class.libraries__view-btn--active]="viewMode === 'table'"
              (click)="setViewMode('table')"
              aria-label="Table view"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="2"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" stroke-width="2"/>
              </svg>
              Table
            </button>
          </div>
        </div>

        <!-- Loading -->
        <div class="libraries__empty" *ngIf="loading">
          <p class="libraries__empty-message">Loading library content…</p>
        </div>

        <!-- Load error -->
        <div class="libraries__empty" *ngIf="!loading && loadError">
          <p class="libraries__empty-message">{{ loadError }}</p>
        </div>

        <!-- Empty state -->
        <div class="libraries__empty" *ngIf="!loading && !loadError && filteredItems.length === 0">
          <p class="libraries__empty-message">No {{ activeTab }} content available yet.</p>
        </div>

        <!-- Grid view (Video only) -->
        <div class="libraries__grid" *ngIf="!loading && !loadError && filteredItems.length > 0 && viewMode === 'grid' && activeTab === 'video'">
          <article
            *ngFor="let item of displayedItems"
            class="library-card"
            [class.library-card--article]="item.type === 'article'"
          >
            <a [href]="item.linkUrl" target="_blank" rel="noopener noreferrer" class="library-card__link-wrap">
              <div class="library-card__thumb">
                <img
                  *ngIf="item.thumbnailUrl"
                  [src]="item.thumbnailUrl"
                  [alt]="item.title"
                  class="library-card__thumb-img"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  (error)="onThumbnailError($event)"
                />
                <div *ngIf="!item.thumbnailUrl" class="library-card__thumb-placeholder" [attr.aria-label]="item.title"></div>
                <div class="library-card__play-icon" *ngIf="item.type === 'video'" aria-hidden="true">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.9)" stroke="rgba(255,255,255,0.5)" stroke-width="2"/>
                    <path d="M10 8l6 4-6 4V8z" fill="#059669"/>
                  </svg>
                </div>
              </div>
              <div class="library-card__body">
                <h3 class="library-card__title">{{ item.title }}</h3>
                <p class="library-card__desc">{{ item.description }}</p>
                <p class="library-card__meta" *ngIf="item.lastUpdated">Last updated: {{ item.lastUpdated }}</p>
              </div>
            </a>
          </article>
        </div>

        <!-- Table view (Articles always; Video when Table selected) -->
        <div class="libraries__table-wrap" *ngIf="!loading && !loadError && filteredItems.length > 0 && (viewMode === 'table' || activeTab === 'article')">
          <table class="libraries__table">
            <thead>
              <tr>
                <th class="libraries__table-th libraries__table-th--title" scope="col">Title</th>
                <th class="libraries__table-th libraries__table-th--desc" scope="col">Description</th>
                <th class="libraries__table-th libraries__table-th--action" scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of displayedItems"
                class="libraries__table-row"
              >
                <td class="libraries__table-td libraries__table-td--title">
                  <a [href]="item.linkUrl" target="_blank" rel="noopener noreferrer" class="libraries__table-link">{{ item.title }}</a>
                </td>
                <td class="libraries__table-td libraries__table-td--desc">{{ item.description }}</td>
                <td class="libraries__table-td libraries__table-td--action">
                  <a [href]="item.linkUrl" target="_blank" rel="noopener noreferrer" class="libraries__table-action" >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <polyline points="15 3 21 3 21 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Load More -->
        <div class="libraries__load-more" *ngIf="!loading && !loadError && filteredItems.length > 0 && hasMoreItems">
          <button type="button" class="libraries__load-more-btn" (click)="loadMore()">
            Load More
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
